/**
 * 跳转到sso登录页
 */
export function getLoginPath (href) {
  href = href || location.href
  const host = {
    'production': 'https://sso.xueshicloud.com',
    'development': 'http://localhost:8061',
    'lan': 'http://xueshicloud-sso.youpin-k8s.net'
  }[process.env.NODE_ENV]
  return `${host}?redirect_path=${encodeURIComponent(href)}`
}

/**
 * 学识云官网链接及端口
 */
export const xueshiHomePath = {
  'production': 'https://xueshicloud.com/',
  'development': 'http://localhost:8063',
  'lan': 'http://xueshicloud.youpin-k8s.net'
}[process.env.NODE_ENV]

/**
 * 跳转到手机端去加入团队
 */
export const mobileJoinTeamPath = {
  'production': 'http://192.168.1.44:8066',
  'development': 'http://192.168.1.44:8066',
  'lan': 'http://192.168.1.44:8066'
}[process.env.NODE_ENV]



// WEBPACK FOOTER //
// ./src/utils/assist.js